import { z } from "zod";
import { searchParam } from "@amber/ui";

export const tasksSearchSchema = z.object({
  scope: searchParam(z.enum(["actionable", "all"])),
  view: searchParam(z.enum(["open", "done"])),
  type: searchParam(z.string()),
  person: searchParam(z.string()),
  platform: searchParam(z.string()),
  age: searchParam(z.enum(["day", "week", "older"])),
  q: searchParam(z.string()),
});
export type TasksSearch = z.infer<typeof tasksSearchSchema>;
